module.exports = __webpack_public_path__ + "static/media/Aab e hayat.d9b556ee.png";